import { useEffect, useState } from 'react';
import { IoTriangleSharp } from 'react-icons/io5';
import { useParams } from 'react-router-dom';
import { GameHeader } from '../../components/GameHeader';
import { Sidebar } from '../../components/Sidebar';

import { usePopup } from '../../hooks/popup';
import { useTimerContext } from '../../hooks/TimerContext';
import { getRebus, iRebus } from '../../interfaces/rebus';
import { Container, Content, GameContent } from './styles';

export const Rebus: React.FC = () => {
  const { handleStopTimer, resetTimer } = useTimerContext();

  const [rebus, setRebus] = useState<iRebus>({} as iRebus);
  const [isFinished, setIsFinished] = useState(false);
  const [score, setScore] = useState(0);
  const [inputValue, setInputValue] = useState<string>('');

  const [isHintUsed, setIsHintUsed] = useState(false);

  const { id } = useParams();
  const { mountPopup } = usePopup();

  useEffect(() => {
    const getCurrentRebus = async () => {
      const rebus = await getRebus(Number(id));
      setRebus(rebus);
    };
    getCurrentRebus();
  }, [id]);

  const revealAnswer = () => {
    setScore(0);
    setIsHintUsed(true);
    setInputValue(rebus.solucao);
  };

  const handleRevealWord = () => {
    const splittedSolution = rebus.solucao.split(' ');
    const splittedInputValue = inputValue.split(' ');
    const word = splittedInputValue[splittedInputValue.length - 1].split('');
    const resposta = splittedSolution[splittedInputValue.length - 1].split('');
    let aux = inputValue;

    if (resposta !== undefined && word.length < resposta.length) {
      for (let i = word.length; i < resposta.length; i++) {
        aux = aux + resposta[i];
      }
      setInputValue(aux);
    } else {
      let aux = inputValue + ' ';
      setInputValue(aux);
    }

    setScore(0);
    setIsHintUsed(true);
  };

  const handleRevealLetter = () => {
    const splittedSolution = rebus.solucao.split('');
    const splittedInputValue = inputValue.split('');

    if (splittedSolution[splittedInputValue.length] !== undefined) {
      setInputValue(inputValue + splittedSolution[splittedInputValue.length]);
    }

    setScore(0);
    setIsHintUsed(true);
  };

  const checkAnswer = async () => {
    setIsFinished(true);
    mountPopup({
      title: 'Deseja realmente Finalizar o jogo?',
      message: 'Boa sorte!',
      type: 'alegre',
      buttons: [
        {
          buttonText: 'sim',
          buttonFunction: async () => {
            handleStopTimer();

            setTimeout(() => {
              mountPopup({
                title: 'Jogo concluído!',
                message: 'Você concluiu este passatempo, parabéns!',
                buttons: [
                  {
                    buttonText: 'ok!',
                    isPurple: true,
                  },
                ],
                type: 'sucesso',
              });

              const splittedSolution = rebus.solucao.split('');
              const splittedInputValue = inputValue.toUpperCase().split('');

              let finalScore = 0;

              splittedSolution.forEach((element, i) => {
                if (element === splittedInputValue[i]) {
                  finalScore++;
                }
              });

              isHintUsed ? setScore(0) : setScore(finalScore * 2);
            }, 500);
          },
        },
        {
          buttonText: 'não',
          isPurple: true,
        },
      ],
    });
  };

  const resetRebus = () => {
    setInputValue('');
    setScore(0);
    setIsFinished(false);
    setIsHintUsed(false);
    resetTimer();
  };

  return (
    <Container>
      <GameHeader
        type="REBUS"
        maxScore={rebus.solucao ? rebus.solucao.length * 2 : 0}
        currentScore={score}
        menuItems={[
          {
            buttonFunctions: () => {
              checkAnswer();
            },
            buttonText: 'Verificar acertos',
          },
          {
            buttonFunctions: () => {
              mountPopup({
                title: 'Deseja revelar a resposta?',
                message: 'Se utilizar a ajuda, sua pontuação será zerada!',
                buttons: [
                  {
                    buttonText: 'Sim',
                    buttonFunction: () => {
                      revealAnswer();
                    },
                  },
                  {
                    buttonText: 'Não',
                    isPurple: true,
                  },
                ],
                type: 'atencao',
              });
            },
            buttonText: 'Revelar resposta',
          },
          {
            buttonFunctions: () => {
              mountPopup({
                title: 'Deseja revelar uma palavra?',
                message: 'Se utilizar a ajuda, sua pontuação será zerada!',
                buttons: [
                  {
                    buttonText: 'Sim',
                    buttonFunction: () => {
                      handleRevealWord();
                    },
                  },
                  {
                    buttonText: 'Não',
                    isPurple: true,
                  },
                ],
                type: 'atencao',
              });
            },
            buttonText: 'Revelar palavra',
          },
          {
            buttonFunctions: () => {
              mountPopup({
                title: 'Deseja revelar uma letra?',
                message: 'Se utilizar a ajuda, sua pontuação será zerada!',
                buttons: [
                  {
                    buttonText: 'Sim',
                    buttonFunction: () => {
                      handleRevealLetter();
                    },
                  },
                  {
                    buttonText: 'Não',
                    isPurple: true,
                  },
                ],
                type: 'atencao',
              });
            },
            buttonText: 'Revelar letra',
          },
          {
            buttonFunctions: () => {
              mountPopup({
                title: 'Deseja realmente limpar o jogo?',
                message:
                  'Se sim, a pontuação será zerada e o jogo recomeçará do início!',
                buttons: [
                  {
                    buttonText: 'sim',
                    buttonFunction: () => {
                      resetRebus();
                    },
                  },
                  {
                    buttonText: 'não',
                    isPurple: true,
                  },
                ],
                type: 'atencao',
              });
            },
            buttonText: 'Limpar jogo',
          },
        ]}
      />

      <Content>
        <GameContent>
          {rebus && <span>{rebus.numeracao}</span>}
          <div>
            <main>
              <img src={rebus && rebus.imagem} alt="Rébus Game" />

              <input
                disabled={isFinished}
                type="text"
                name="answer"
                value={inputValue}
                onChange={(event) => setInputValue(event.target.value)}
                placeholder="DIGITE AQUI SUA RESPOSTA"
              />
            </main>

            <Sidebar
              currentScore={score}
              type="REBUS"
              text={rebus && rebus.numeracao}
              maxScore={rebus.solucao ? rebus.solucao.length * 2 : 0}
              menuItems={[
                {
                  buttonFunctions: () => {
                    checkAnswer();
                  },
                  buttonText: 'Verificar acertos',
                },
                {
                  buttonFunctions: () => {
                    mountPopup({
                      title: 'Deseja revelar a resposta?',
                      message:
                        'Se utilizar a ajuda, sua pontuação será zerada!',
                      buttons: [
                        {
                          buttonText: 'Sim',
                          buttonFunction: () => {
                            revealAnswer();
                          },
                        },
                        {
                          buttonText: 'Não',
                          isPurple: true,
                        },
                      ],
                      type: 'atencao',
                    });
                  },
                  buttonText: 'Revelar resposta',
                },
                {
                  buttonFunctions: () => {
                    mountPopup({
                      title: 'Deseja revelar uma palavra?',
                      message:
                        'Se utilizar a ajuda, sua pontuação será zerada!',
                      buttons: [
                        {
                          buttonText: 'Sim',
                          buttonFunction: () => {
                            handleRevealWord();
                          },
                        },
                        {
                          buttonText: 'Não',
                          isPurple: true,
                        },
                      ],
                      type: 'atencao',
                    });
                  },
                  buttonText: 'Revelar palavra',
                },
                {
                  buttonFunctions: () => {
                    mountPopup({
                      title: 'Deseja revelar uma letra?',
                      message:
                        'Se utilizar a ajuda, sua pontuação será zerada!',
                      buttons: [
                        {
                          buttonText: 'Sim',
                          buttonFunction: () => {
                            handleRevealLetter();
                          },
                        },
                        {
                          buttonText: 'Não',
                          isPurple: true,
                        },
                      ],
                      type: 'atencao',
                    });
                  },
                  buttonText: 'Revelar letra',
                },
                {
                  buttonFunctions: () => {
                    mountPopup({
                      title: 'Deseja realmente limpar o jogo?',
                      message:
                        'Se sim, a pontuação será zerada e o jogo recomeçará do início!',
                      buttons: [
                        {
                          buttonText: 'sim',
                          buttonFunction: () => {
                            resetRebus();
                          },
                        },
                        {
                          buttonText: 'não',
                          isPurple: true,
                        },
                      ],
                      type: 'atencao',
                    });
                  },
                  buttonText: 'Limpar jogo',
                },
              ]}
            />
          </div>
        </GameContent>
        <p style={{ background: '#000' }}>
          VER MAIS COMENTÁRIOS <IoTriangleSharp size={12} />
        </p>
      </Content>
    </Container>
  );
};
